import styled from "styled-components"

export const DeleteUserManagementRecordWrapper = styled.div`
	background-color: rgba(0, 0, 0, 0.14);
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: center;
	.module {
		border-radius: 16px;
		padding: 32px;
		background-color: #fff;
		width: max-content;
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
		gap: 12px;
		div {
			&.closeSection {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				font-size: 24px;
				cursor: pointer;
			}
			&:nth-child(2) {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				gap: 12px;
				> div {
					width: 50px;
					height: 50px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 24px;
					background: #e85b5b17;
					border-radius: 4px;
				}
				p {
					margin: 0;
					font-weight: 700;
					font-size: 20px;
					line-height: 22px;
					color: #261b6a;
				}
			}
			&:nth-child(3) {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 16px;
				margin-top: 22px;
			}
		}
	}
`
